import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/feedback/web/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function replyFeedback(data) {
  return request.send({
    url: `/pmy/sys/feedback/reply`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
